import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminHomePage from '../adminapp/pages/AdminHomePage';
import ProtectedRouteAdmin from './ProtectedRouteAdmin';
import AdminLeadsPage from '../adminapp/pages/AdminLeadsPage';
import AdminUsersPage from '../adminapp/pages/AdminUsersPage';

const AdminRouter = () => (
  <Routes>

    <Route element={<ProtectedRouteAdmin />}>
      <Route path="/" element={<AdminHomePage />} />
      <Route path="/leads" element={<AdminLeadsPage />} />
      <Route path="users" element={<AdminUsersPage />} />
    </Route>

  </Routes>
);

export default AdminRouter;